import { useQuery } from '@tanstack/react-query';
import apiClient from './apiClient';

const historicalActionKeys = {
  all: ['historicalActions'],
  list: (params) => [...historicalActionKeys.all, params],
  modules: () => ['historicalActionModules'],
};

export const useHistoricalActionModules = () => {
  return useQuery({
    queryKey: historicalActionKeys.modules(),
    queryFn: async () => {
      const response = await apiClient.get('historical_actions/modules');
      if (response.data?.items) return response.data.items;
      return response.data || [];
    },
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};

export const useHistoricalActions = (params, options = {}) => {
  return useQuery({
    queryKey: historicalActionKeys.list(params),
    queryFn: async () => {
      const response = await apiClient.get('historical_actions', { params });
      return response.data;
    },
    keepPreviousData: true,
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
    ...options,
  });
};
